import React from "react";
import { ElementComponentProps } from "elements/types";
import { CheckboxElement } from "records/Element";
import CheckboxReactive from "./CheckboxReactive";
import CheckboxOnApply from "./CheckboxOnApply";
import { extractOnApplyParameters } from "elements/utils";

function CheckboxContainer(props: ElementComponentProps<CheckboxElement>) {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<CheckboxOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<CheckboxReactive {...props} />
	);
}

export default React.memo(CheckboxContainer);
